import type { FC } from 'react';
import { useMemo, useState } from 'react';

import dynamic from 'next/dynamic';

import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './styles.module.css';

const ZoomableImage = dynamic(() => import('../ZoomableImage'), { ssr: false });

interface Props {
    data: string[];
}

const ThumbsGallery: FC<Props> = ({ data }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const slides = useMemo(
        () =>
            data.map(url => (
                <SwiperSlide key={url}>
                    <ZoomableImage
                        src={url}
                        alt='Ảnh lỗi'
                        noPreview
                        trigger={
                            <img
                                src={url}
                                alt='thumbnail'
                                style={{ width: '100%', cursor: 'pointer' }}
                            />
                        }
                        previewSizes='(max-width:600px) 90vw, 60vw'
                    />
                </SwiperSlide>
            )),
        [data]
    );

    return (
        <div className={styles['thumbs-gallery']}>
            <Swiper
                style={{
                    '--swiper-navigation-color': 'rgba(0,0,0,0.8)',
                    '--swiper-navigation-size': '24px',
                }}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className='thumbs-swiper'
            >
                {slides}
            </Swiper>
            {data.length > 1 && (
                <Swiper
                    onSwiper={swiper => setThumbsSwiper(swiper)}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode
                    watchSlidesProgress
                    modules={[FreeMode, Navigation, Thumbs]}
                    className='thumbs-swiper-mini'
                >
                    {slides}
                </Swiper>
            )}
        </div>
    );
};

export default ThumbsGallery;
